import React, { useEffect } from 'react'

export const Blogs = () => {
  useEffect(() => {
    document.title = 'Abhinav - Blogs';
  }, []);
  return (
    <div className='container'>Blogs</div>
  )
}
